import { NgModule } from '@angular/core';
import {
  MarineInsuranceBeneficiaryViewCardComponent,
  MarineInsuranceBeneficiaryViewDataComponent,
  MarineInsuranceCardComponent,
  MarineInsuranceCommoditiesViewManagementCardComponent,
  MarineInsuranceDisclaimerCardComponent,
  MarineInsuranceFromToFormComponent,
  MarineInsuranceFromToViewCardComponent,
  MarineInsuranceIndicatorComponent,
  MarineInsurancePaymentBreakdownComponent,
  MarineInsurancePaymentButtonComponent,
  MarineInsurancePaymentsManagementCardComponent,
  MarineInsuranceQuoteManagementViewCardComponent,
  MarineInsuranceQuotePricingCardComponent,
  MarineInsuranceQuoteShipmentDetailsCardComponent,
  MarineInsuranceQuoteUpdatedPricingCardComponent,
  MarineInsuranceQuoteValueCommodityCardComponent,
  MarineInsuranceQuoteViewCardComponent,
  MarineInsuranceQuoteViewDataComponent,
  MarineInsuranceReminderModalComponent,
  MarineInsuranceShipmentDetailsViewManagementCardComponent,
  MarineInsuranceSidebarBeneficiaryFormComponent,
  MarineInsuranceSidebarDescriptionManagementFormComponent,
  MarineInsuranceSidebarFromToFormComponent,
  MarineInsuranceSidebarQuoteFormComponent,
  MarineInsuranceSidebarQuoteManagementFormComponent,
  MarineInsuranceSidebarShipmentDetailsFormComponent,
  MarineInsuranceTermsDataComponent,
} from './components';
import { TranslateModule } from '@ngx-translate/core';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { CommonModule } from '@angular/common';
import { CustomTooltipModule } from '@shared/tooltip/custom-tooltip.module';
import { RouterModule } from '@angular/router';
import { AddressModule } from '@shared/address/address.module';
import { InputPhoneModule } from '@shared/input-phone/input-phone.module';
import { CardsModule } from '@shared/cards/cards.module';
import { PaymentButtonExternalModule } from '@shared/payment-button-external/payment-button-external.module';
import { PaymentButtonSharedModule } from '@shared/payment-button-shared';
import { DocumentModule } from '@shared/document/document.module';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';

@NgModule({
  declarations: [
    MarineInsuranceCardComponent,
    MarineInsuranceSidebarQuoteFormComponent,
    MarineInsuranceQuoteViewCardComponent,
    MarineInsuranceQuoteViewDataComponent,
    MarineInsuranceQuotePricingCardComponent,
    MarineInsurancePaymentBreakdownComponent,
    MarineInsuranceBeneficiaryViewDataComponent,
    MarineInsuranceBeneficiaryViewCardComponent,
    MarineInsuranceSidebarBeneficiaryFormComponent,
    MarineInsuranceTermsDataComponent,
    MarineInsuranceQuoteValueCommodityCardComponent,
    MarineInsuranceQuoteShipmentDetailsCardComponent,
    MarineInsuranceFromToViewCardComponent,
    MarineInsuranceFromToFormComponent,
    MarineInsuranceSidebarFromToFormComponent,
    MarineInsuranceDisclaimerCardComponent,
    MarineInsurancePaymentButtonComponent,
    MarineInsuranceQuoteManagementViewCardComponent,
    MarineInsuranceQuoteUpdatedPricingCardComponent,
    MarineInsurancePaymentsManagementCardComponent,
    MarineInsuranceCommoditiesViewManagementCardComponent,
    MarineInsuranceSidebarDescriptionManagementFormComponent,
    MarineInsuranceShipmentDetailsViewManagementCardComponent,
    MarineInsuranceSidebarShipmentDetailsFormComponent,
    MarineInsuranceSidebarQuoteManagementFormComponent,
    MarineInsuranceIndicatorComponent,
    MarineInsuranceReminderModalComponent,
  ],
  imports: [
    CommonModule,
    MutualModule,
    TranslateModule,
    PipesSharedModule,
    CustomTooltipModule,
    BsDropdownModule.forRoot(),
    NzPopoverModule,
    RouterModule,
    AddressModule,
    InputPhoneModule,
    CardsModule,
    PaymentButtonExternalModule,
    PaymentButtonSharedModule,
    DocumentModule,
    CustomModalModule,
  ],
  exports: [
    MarineInsuranceCardComponent,
    MarineInsuranceSidebarQuoteFormComponent,
    MarineInsuranceQuoteViewCardComponent,
    MarineInsuranceQuoteViewDataComponent,
    MarineInsuranceQuotePricingCardComponent,
    MarineInsurancePaymentBreakdownComponent,
    MarineInsuranceBeneficiaryViewDataComponent,
    MarineInsuranceBeneficiaryViewCardComponent,
    MarineInsuranceSidebarBeneficiaryFormComponent,
    MarineInsuranceTermsDataComponent,
    MarineInsuranceQuoteValueCommodityCardComponent,
    MarineInsuranceQuoteShipmentDetailsCardComponent,
    MarineInsuranceFromToViewCardComponent,
    MarineInsuranceFromToFormComponent,
    MarineInsuranceSidebarFromToFormComponent,
    MarineInsuranceDisclaimerCardComponent,
    MarineInsurancePaymentButtonComponent,
    MarineInsuranceQuoteManagementViewCardComponent,
    MarineInsuranceQuoteUpdatedPricingCardComponent,
    MarineInsurancePaymentsManagementCardComponent,
    MarineInsuranceCommoditiesViewManagementCardComponent,
    MarineInsuranceSidebarDescriptionManagementFormComponent,
    MarineInsuranceShipmentDetailsViewManagementCardComponent,
    MarineInsuranceSidebarShipmentDetailsFormComponent,
    MarineInsuranceSidebarQuoteManagementFormComponent,
    MarineInsuranceIndicatorComponent,
    MarineInsuranceReminderModalComponent,
  ],
})
export class MarineInsuranceSharedModule {}
